<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMeetings_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m14.895 18.79.764 2.291a.658.658 0 0 1-.624.866h-6.07a.658.658 0 0 1-.624-.866l.764-2.291h5.79ZM4.737 3h14.526A2.737 2.737 0 0 1 22 5.737V15a2.737 2.737 0 0 1-2.737 2.737H4.737A2.737 2.737 0 0 1 2 15V5.737A2.737 2.737 0 0 1 4.737 3Zm14.526 13.158c.64 0 1.158-.518 1.158-1.158V5.737c0-.64-.519-1.158-1.158-1.158H4.737c-.64 0-1.158.519-1.158 1.158V15c0 .64.519 1.158 1.158 1.158h14.526ZM6 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6Zm5 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V7Zm-5 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Z"
        clip-rule="evenodd"
    />
</svg>
